import React, { Component } from 'react'
import View from './view'
import Success from './success'
import './change-password.css'
import { getReturnUrl, getUser } from '../utils/queryParams'
import { passwordSatisfiesPolicy } from '../utils/passwordPolicyValidator'

class ChangePassword extends Component {
  constructor(props) {
    super(props)

    this.returnUrl = getReturnUrl()
    this.prefilledUser = getUser()

    this.state = {
      user: this.prefilledUser,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      errors: {},
      loading: false,
      success: false
    }
  }

  sendChangePassword = (user, currentPassword, newPassword) => {
    user = user.toLowerCase()
    this.setState({ loading: true })

    this.authenticateUser(user, currentPassword)
      .then(authToken => {
        return this.changePassword(authToken, currentPassword, newPassword)
          .then(resp => resp)
      })
      .then(() => this.setState({ success: true }))
      .catch(() => { }).then(() => this.setState({ loading: false }))
  }

  authenticateUser = (username, password) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/auth`,
      {
        method: 'POST',
        headers: new Headers({ 'content-type': 'application/json' }),
        credentials: 'include',
        body: JSON.stringify({ 'user': username, 'password': password })
      }
    )
      .then(resp => {
        if (!resp.ok) return Promise.reject(resp)
        return resp.json()
      })
      .then(resp => resp.data.token)
      .catch(err => {
        this.setState({
          errors: {
            user: ['Your username or password is incorrect'],
            currentPassword: ['Your username or password is incorrect']
          }
        })
        throw err
      })
  }

  changePassword = (authToken, currentPassword, newPassword) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/v1/change-password`,
      {
        method: 'POST',
        headers: new Headers({
          'content-type': 'application/json',
          'authorization': `Bearer ${authToken}`
        }),
        credentials: 'include',
        body: JSON.stringify({ 'current_password': currentPassword, 'new_password': newPassword })
      }
    )
      .then(resp => {
        if (!resp.ok) return Promise.reject(resp)
        return resp.json()
      })
      .then(data => data)
      .catch(err => {
        if (err.status >= 400 && err.status <= 499) {
          this.setState({
            errors: {
              newPassword: ['Your password does not meet our password policy']
            }
          })
        }
        if (err.status >= 500 && err.status <= 599) {
          this.setState({
            errors: {
              summary: ['An error occured while changing your password, please wait a few minutes and try again']
            }
          })
        }

        throw err
      })
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.setState({errors: {}})

    if(this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        loading: false,
        errors: {
          newPassword: ['Your passwords do not match'],
          confirmPassword: ['Your passwords do not match'],
        }
      })
      return
    }

    if (!passwordSatisfiesPolicy(this.state.newPassword)) {
      this.setState({
        errors: {
          newPassword: ['New Password does not meet requirements'],
          passwordPolicy: ['New Password does not meet requirements']
        }
      })
      return
    }

    this.sendChangePassword(this.state.user, this.state.currentPassword, this.state.newPassword)
  }

  render() {
    return (
      this.state.success ?
        <Success returnUrl={this.returnUrl} /> :
        <View
          prefilledUser={this.prefilledUser}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          sendChangePassword={this.sendChangePassword}
          newPassword={this.state.newPassword}
          loading={this.state.loading}
          errors={this.state.errors}
        />
    )
  }
}

export default ChangePassword



// WEBPACK FOOTER //
// ./src/change-password/index.js